// postMessage origins. Compare scheme, host, and port. Do not match a substring.
//
// public/tt_embed.js runs on the shop and receives messages from the configurator.
// EmbedController runs in the iframe and receives messages from the shop.
// embed-test.html loads both on http://localhost (any port); that host is allowed
// on both sides because each listener runs in local embed dev.

const CONFIGURATOR_ORIGINS = ["https://custom.calipercovers.com", "https://mgp.tastetest3d.com"];

const SHOP_ORIGINS = [
  "https://mgp-caliper-covers-hzajihy6.myshopify.com",
  "https://calipercovers.com",
  "https://www.calipercovers.com",
];

export function isHttpLocalhostOrigin(origin) {
  if (typeof origin !== "string") return false;
  let url;
  try {
    url = new URL(origin);
  } catch (err) {
    return false;
  }
  return url.protocol === "http:" && url.hostname === "localhost" && url.origin === origin;
}

export function isAllowedConfiguratorOrigin(origin) {
  return CONFIGURATOR_ORIGINS.includes(origin) || isHttpLocalhostOrigin(origin);
}

export function isAllowedShopOrigin(origin) {
  return SHOP_ORIGINS.includes(origin) || isHttpLocalhostOrigin(origin);
}
